import styled from '@emotion/styled';
import { Grid } from '@kc-console/common-ui';
import { InServiceUsefulInfo, PageHeader } from '@kc-console/shared-ui';

import type { PropsWithChildren } from 'react';
import type { InServiceUsefulInfoProps, PageHeaderProps } from '@kc-console/shared-ui';

/**
 * 서비스 내 에러 레이아웃 컴포넌트
 *
 * @description
 * 서비스 내에서 표시되는 에러 컴포넌트를 위한 레이아웃입니다.
 * 세로 방향 플렉스 컨테이너로 자식 요소들을 배치합니다.
 *
 * @example
 * ```tsx
 * <InServiceErrorLayout>
 *   <InServiceNoPermission />
 *   <InServiceUsefulInfo />
 * </InServiceErrorLayout>
 * ```
 */
export const InServiceErrorLayout = ({
  headerProps,
  usefulInfoProps,
  children,
}: PropsWithChildren<{
  headerProps?: PageHeaderProps;
  usefulInfoProps?: InServiceUsefulInfoProps;
}>) => {
  return (
    <LayoutWrapperRoot container flexDirection="column">
      {headerProps && <PageHeader showBottomDivider {...headerProps} />}
      {children}
      {usefulInfoProps && <InServiceUsefulInfo {...usefulInfoProps} />}
    </LayoutWrapperRoot>
  );
};

const LayoutWrapperRoot = styled(Grid)`
  width: 100%;
  height: 100%;
  padding: 32px;
  flex-wrap: nowrap;
  gap: 32px;
  min-width: 800px;
`;
